__webpack_public_path__ =
  JSON.parse(document.getElementById("config").innerText).staticURI || "/";
